<template>
  <div class="commonFoot">
    <div class="container"> 
        <div class="links"> 
             <router-link :to="{path:'/ExistingEvidence/Show'}">版权存证</router-link>
              |
             <router-link :to="{path:'/Register/Show'}">版权登记</router-link>
              |
             <router-link :to="{path:'/NewsList'}">新闻中心</router-link>
              |
            <router-link :to="{path:'/Platform'}">关于我们</router-link>
        </div>
        <div class="copyRight"> 
          ©2022 湖北省数字版权综合服务平台 版权所有 保留一切权利
        </div>
          <a href="https://beian.miit.gov.cn/" target="_blank" class="text-light-gray">ICP备案：鄂ICP备2021022303号-2</a> 
     </div>
  </div>
</template>

<script>
export default {
  name: 'FootBlock',

  data () {
    return {
    }
  },

  methods: {}
}
</script>

<style lang='scss'>
    .commonFoot{
        width: 100%;
        background:#f1f1f1;
        text-align: center;
        padding:32px 0 24px;
        .links{
           color:#999;
            a{
                color:#999;
                margin:0 8px;
                text-decoration: none;
                opacity: 0.9;
            }
            a:hover{
              opacity: 1;
            }
        }
        .copyRight{
          color:#999;
          border-top:solid 1px rgba(0,0,0,0.1);
          padding-top:24px;
          margin-top:24px;
        }
        .text-light-gray{
          color:#999;
        }
    }
</style>
